<!-- 主页 -->
<template>
  <div class="index">
    <Top :headShow='headShow' :uInfo='uInfo'></Top>
    <!-- <div id="jiange"></div> -->
    <Rotation :type="lbt"></Rotation>


    <div class="banxin">
      <!-- 头部介绍盒子 -->
      <div class="top1box">
        <div class="box1" @click="goMarket(0)">
          <div class="imgbox">

            <div class="img">
              <img :src="require('../imgs/homea.svg')">
            </div>
          </div>
          <p>全国高端文旅视觉版权素材</p>
          <div class="text">
            <div class="t1">

              <p><span>·</span> 精品文旅图片/视频素材</p>
              <p><span>·</span> 灵活的授权方式</p>
              <p><span>·</span> 多种套餐与行业解决方案</p>
            </div>
            <div class="t2">

              <p><span>·</span> 云存储、标签化服务</p>
              <p><span>·</span> 时间戳确权</p>
              <p><span>·</span> 取证、法律维权服务</p>
            </div>
          </div>
        </div>
        <div class="box2" @click="goMarket(1)">
          <div class="imgbox">

            <div class="img">
              <img :src="require('../imgs/homeb.svg')">
            </div>
          </div>
          <p>拍摄服务</p>
          <div class="text">

            <p><span>·</span> 摄影大咖特约拍摄</p>
            <p><span>·</span> 文旅风光/活动定制拍摄</p>
            <p><span>·</span> 摄影大赛/影像征集</p>
          </div>
        </div>
        <div class="box2" @click="goMarket(2)">
          <div class="imgbox">

            <div class="img">
              <img :src="require('../imgs/homec.svg')">
            </div>

          </div>
          <p>数字影像馆建设</p>
          <div class="text">

            <p><span>·</span> 独立影像馆建设</p>
            <p><span>·</span> 会员合作建馆 </p>
            <p><span>·</span> 内容创作与平台运营</p>
          </div>
        </div>
        <div class="box2" @click="goMarket(3)">
          <div class="imgbox">

            <div class="img">
              <img :src="require('../imgs/homed.svg')">
            </div>
          </div>
          <p>文旅摄影品牌打造</p>
          <div class="text">

            <p><span>·</span> 摄影小镇挖掘与打造</p>
            <p><span>·</span> 线下影展策展开展</p>
            <p><span>·</span> 画册设计与图书出版</p>
          </div>
        </div>
        <div class="box2" @click="goMarket(4)">
          <div class="imgbox">

            <div class="img">
              <img :src="require('../imgs/homee.svg')">
            </div>
          </div>
          <p>VR体验馆打造与运营</p>
          <div class="text">

            <p><span>·</span> VR素材拍摄</p>
            <p><span>·</span> VR实景线上影像展</p>
            <p><span>·</span> VR体验馆打造与运营</p>
          </div>
        </div>
      </div>

      <!-- 征稿/活动 -->

      <div class="jpimgtop">
        <span class="text"><i class="icon"></i>大赛征稿</span>
      </div>
      <div class="active-name" v-if="dataRes.length">
        <div :style="{ backgroundImage: `url(${imgUrl})` }" @click="$router.push({ path: `/activeDetail?id=${item.id}` })"
          class="name-img" v-for="item in dataRes.slice(0, 3)" :key="item.id">

          <img class="special"
            :src="item.cover.substring(0, 4) !== 'http' ? 'https://www.yunshangzg.com/' + item.cover : item.cover" />
        </div>
      </div>



      <!-- 精品图片 -->
      <div class="jpimgtop">
        <span class="text"><i class="icon"></i>精品图片</span>
        <span id="big" class="imgMore" @click="$router.push('/gallery')" style="cursor: pointer;">查看更多</span>
      </div>

      <div class="jpimgbox" v-if="dataPhoto.length">
        <div class="jpimgcon">
          <!-- <div class="rotation2"> -->
          <el-carousel trigger="click" class="demonstration-img">
            <el-carousel-item v-for="item in dataPhoto.slice(0, 3)" :key="item + Math.random()">
              <div id="posTop">
                <div class="address">
                  {{ item.address }}
                </div>
              </div>
              <div id="posBottom">
                <img :src="item.headImage" alt="">
                <div class="name">{{ item.username }}</div>
              </div>
              <img v-lazy="`${item.photoUrl}?x-oss-process=image/resize,h_600`" @click="pushPhotoDetial(item.photoId)" />

              <!-- <h3 class="small">{{ item }}</h3> -->
            </el-carousel-item>

          </el-carousel>
          <template>
            <div class="imgBox" style="overflow: hidden;" @click="pushPhotoDetial(item.photoId)"
              v-for="item in dataPhoto.slice(3)" :key="item.photoId + Math.random()">
              <div id="posTop">
                <div class="address">
                  {{ item.address }}
                </div>
              </div>
              <div id="posBottom">
                <img :src="item.headImage" alt="">
                <div class="name">{{ item.username }}</div>
              </div>
              <img class="yyyyy" v-lazy="`${item.photoUrl}?x-oss-process=image/resize,h_300`" />
            </div>
          </template>

        </div>
      </div>

      <!-- 精品视频 -->

      <div class="jpimgtop">
        <span class="text"><i class="icon"></i>精品视频</span>
        <span id="big" class="imgMore" @click="$router.push('/videosource')" style="cursor: pointer;">查看更多</span>
      </div>
      <div id="myTabContent" class="jpvideobox tab-content " v-if="dataVideo.length">
        <div class="jpvideocon tab-pane fade in active" id="home">
          <!-- <div class="rotation2"> -->

          <template>
            <div class="vBox">
              <div id="posTop">
                <div class="address">
                  {{ dataVideo[0].address }}
                </div>
              </div>
              <div id="posBottom">
                <img :src="dataVideo[0].headImage" alt="">
                <div class="name">{{ dataVideo[0].username }}</div>
              </div>
              <div class="shichang" v-html="formatSeconds(dataVideo[0].duration)"></div>
              <img v-lazy="dataVideo[0].coverUrl + '?x-oss-process=image/resize,h_600'"
                @click="pushVideoDetial(dataVideo[0].videoId)" />
            </div>
          </template>



          <template>
            <div class="imgBox2" @click="pushVideoDetial(item.videoId)" v-for="(item, index) in dataVideo.slice(1)"
              :key="index">
              <div id="posTop">
                <div class="address">
                  {{ item.address }}
                </div>
              </div>
              <div id="posBottom">
                <img :src="item.headImage" alt="">
                <div class="name">{{ item.username }}</div>
              </div>
              <div class="shichang" v-html="formatSeconds(item.duration)"></div>
              <img :src="item.coverUrl + '?x-oss-process=image/resize,h_300'" alt="" />
            </div>
          </template>

        </div>
      </div>

      <!-- 影像馆 -->
      <div class="jpimgtop">
        <span class="text"><i class="icon"></i>热门目的地影像馆</span>
        <span id="big" class="imgMore" @click="$router.push('/destination')" style="cursor: pointer;">查看更多</span>
      </div>

      <div class="museumBox">
        <!-- 图片位 -->
        <div class="conBox" v-if="imageShop1.length">
          <div class="box1" @click="pushDestinationHome(imageShop1[0].idOrLink)">
            <div class="top">
              <img :src="imageShop1[0].headimage" alt="">
              <p>{{ imageShop1[0].username }}</p>
              <div class="look" @click="pushDestinationHome(imageShop1[0].idOrLink)">立即查看</div>
            </div>

            <el-carousel trigger="click" class="demonstration" style="position: relative;">
              <el-carousel-item v-for="(item, index) in imageShop1[0].showPhoto" :key="index">
                <img :src="item + '?x-oss-process=image/resize,h_600'" />
              </el-carousel-item>
            </el-carousel>

          </div>
          <template>
            <div class="box2" @click="pushDestinationHome(item.idOrLink)" v-for="item in imageShop1.slice(1)"
              :key="item.idOrLink + Math.random()">
              <img :src="item.showPhoto + '?x-oss-process=image/resize,h_300'" alt="">
              <div class="name">{{ item.username }}</div>
              <div class="msk"></div>
            </div>
          </template>
        </div>

        <!-- 文字位 -->
        <div class="museumWord" v-if="imageWord2.length">
          <div class="worditem" v-for="item in imageWord2" :key="item.id" @click="pushDestinationHome(item.idOrLink)">
            <img class="img" :src="item.headimage" alt="">
            <div class="text"> {{ item.username }}</div>
          </div>
        </div>


      </div>



      <!-- 摄影师 -->

      <div class="photographer">
        <div class="sysbox">
          <i class="icon"></i>优秀摄影师
        </div>
        <ul @click="$router.push('/photographer')">
          <li><img src="@/assets/per1.jpg" alt=""></li>
          <li><img src="@/assets/per2.jpg" alt=""></li>
          <li><img src="@/assets/per3.jpg" alt=""></li>
          <li><img src="@/assets/per4.jpg" alt=""></li>
          <li><img src="@/assets/per4.jpg" alt=""></li>
          <li><img src="@/assets/per6.jpg" alt=""></li>
          <li><img src="@/assets/per7.jpg" alt=""></li>
          <li><img src="@/assets/per8.jpg" alt=""></li>
          <li><img src="@/assets/per9.jpg" alt=""></li>
          <li><img src="@/assets/per10.jpg" alt=""></li>
          <li><img src="@/assets/per11.jpg" alt=""></li>
          <li><img src="@/assets/per12.jpg" alt=""></li>
          <li><img src="@/assets/per13.jpg" alt=""></li>
          <li><img src="@/assets/per14.jpg" alt=""></li>
          <li><img src="@/assets/per15.jpg" alt=""></li>
          <li><img src="@/assets/per16.jpg" alt=""></li>
          <li><img src="@/assets/per17.jpg" alt=""></li>
          <li><img src="@/assets/per18.jpg" alt=""></li>

          <li><img src="@/assets/per14.jpg" alt=""></li>
          <li><img src="@/assets/per15.jpg" alt=""></li>
          <li><img src="@/assets/per16.jpg" alt=""></li>
          <li><img src="@/assets/per17.jpg" alt=""></li>

        </ul>
      </div>
      <div class="btns ">
        <!-- <img src="@/imgs/Rectangle 301.png" style="position: relative" /> -->
        <el-button class="btn" @click="$router.push('/contributor')">成为签约摄影师</el-button>
      </div>
    </div>

    <!-- 联系客服 -->
    <service />
    <!-- 回到顶部 -->
    <el-backtop :visibility-height="300">
      <div class="inn">
        <img src="@/imgs/backtop.png" alt="">
      </div>
    </el-backtop>
    <shopFloat />
    <Foot></Foot>
  </div>
</template>

<script>
import service from '@/components/service.vue'
import shopFloat from '@/components/shopFloat.vue';
import { getActiveList } from '@/api/active.js'
import Top from "../components/top";
import Rotation from "./rotation.vue";
import Foot from "./foot.vue";
import Skeleton from "@/components/skeleton.vue"
import { getShopNum } from '@/api/shop.js'

export default {
  name: "index",
  data() {
    return {
      loading: true,
      lbt: 'home',//传给子组件用来区别轮播图
      urlList: [

      ],
      circleUrl: "@/imgs/icon_uplod.png",
      dataArr: [],
      dataPhoto: [],
      dataVideo: [],
      dataRes: [],
      dataAr: [],
      user_url: "",
      isactive: true,
      headShow: false,
      zcShow: true,
      actindex: 1,
      uInfo: {},
      tags: [],
      page: 1,
      imageShop1: [], //图片位影像馆
      imageShopIndex0: [],  //图片位影像馆索引0
      imageShopLBT: [], // 图片位影像馆索引0的轮播图
      imageWord1: [], //文字位影像馆，
      imageWord2: [], //截取前六个
      errobj: {},
      activeId: null,
      token: null, //token
    };
  },
  methods: {
    // 处理微信扫码登录逻辑
    handleLoginFromWx() {
      const data = this.$route.query.data;
      // 如果data不为undefined,说明是微信扫码之后跳转到主页的
      if (data) {
        const wxLoginData = JSON.parse(data);
        if (wxLoginData.token && !wxLoginData.openid) {
          // 如果有token，说明已经注册且登录成功了
          const { headImage, username, token } = wxLoginData; // 把你需要的用户信息提取出来
          console.log(username)

          const Base64 = require('js-base64').Base64
          const urlname = Base64.decode(username) //把base64解码
          console.log(urlname)
          const userInfo = {
            headImage,
            urlname,
            token,
          };
          console.log(userInfo)

          localStorage.clear();
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          // , JSON.stringify(userInfo)
          this.headShow = true;
        } else if (!wxLoginData.token && wxLoginData.openid) { // 没token，需要注册的情况
          const { headimgurl, nickname, sex, openid } = wxLoginData; // 把你需要的用户信息提取出来
          const userInfo = {
            headimgurl,
            nickname,
            openid,
            sex,
          };
          // JSON.stringify(userInfo)
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.$router.push({
            path: '/login',
            query: {
              prog: this.zcShow,
            }
          })

        } else { // 其它情况

        }
      }

    },

    // 获取地址栏参数
    GetQueryString(key) {
      // 获取参数
      var url = window.location.search;
      // 正则筛选地址栏
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
      // 匹配目标参数
      var result = url.substr(1).match(reg);
      //返回参数值
      return result ? decodeURIComponent(result[2]) : null;

    },

    // 去文旅营销
    goMarket(a) {
      // console.log(a);
      this.$router.push(`/marketing?a=${a}`)
    },

    // 获取主页图片
    async hotActivity() {
      try {
        // 征稿 / 活动图片
        const res = await this.$axios.get('/homeReception/findHotActivity')
        // console.log(res);
        this.dataRes = res.data
        // 精品图片
        const res1 = await this.$axios.get('homeReception/findPhotoBoutique')

        this.dataPhoto = res1.data;
        console.log(this.dataPhoto);
        // console.log(this.dataPhoto[3].idOrLink);
        // 精品视频
        const res2 = await this.$axios.get('homeReception/findVideoBoutique')

        this.dataVideo = res2.data;
        console.log(this.dataVideo);
        this.loading = false
      } catch (err) {
        console.log(err);
      }
    },

    // 影像管数据
    // 图片位
    async imageShop() {
      const res = await this.$axios.get('homeReception/findImageShop')
      this.imageShop1 = res.data
      // this.imageShopIndex0 = this.imageShop1[0]
      // // 过滤出不为null的
      // this.imageShopLBT = this.imageShopIndex0.showPhoto.filter(item => {
      //   return item !== null
      // })
      // // console.log(this.imageShopLBT);

    },
    // 文字位
    async imgWord() {
      const res = await this.$axios.get('homeReception/findWord')
      // console.log(res.data);
      this.imageWord1 = res.data
      this.imageWord2 = this.imageWord1.slice(0, 6)
      console.log(this.imageWord2);
    },

    // 点击图片跳转详情页
    pushPhotoDetial(id) {

      let routerUrl = this.$router.resolve({
        path: '/photoDetail',
        query: { id: id }
      })
      // console.log(routerUrl);
      window.open(routerUrl.href, "_brank")
    },


    // 点击视频跳转详情页
    pushVideoDetial(id) {

      let routerUrl = this.$router.resolve({
        path: '/videoDetail',
        query: { id: id }
      })
      // console.log(routerUrl);
      window.open(routerUrl.href, "_brank")
    },

    // 跳转到影像馆主页
    pushDestinationHome(val) {
      // console.log(val);
      let routerUrl = this.$router.resolve({
        path: '/destinationHome',
        query: { id: val }
      })
      // // console.log(routerUrl);
      window.open(routerUrl.href, "_brank")
    },


    // 时长转换
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + (parseInt(secondTime) < 10 ? "0" + parseInt(secondTime) : parseInt(secondTime));

      // if (minuteTime > 0) {

      // }
      if (hourTime > 0) {
        result = "" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime) : parseInt(hourTime)) + ":" + result;

      } else {
        result = "" + (parseInt(minuteTime) < 10 ? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + ":" + result;
      }
      return result;
    },



    //秒转换为mm:ss
    dateFormat(time) {
      let minutes = parseInt(time % (1000 * 60 * 60) / (60));
      let seconds = parseInt(time % (1000 * 60))


      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return minutes + ":" + seconds;
    }
  },
  async created() {

    // let a = encodeURIComponent('5L2p5pavMTEyMQ==')
    // 扫码登录的存token
    if (this.$route.query.date) {
      let ddd = decodeURIComponent(this.$route.query.date)
      console.log(ddd);
      window.localStorage.setItem('userInfo', this.$route.query.date)
      window.localStorage.setItem('token', JSON.parse(this.$route.query.date).token)
    }
    this.token = window.localStorage.getItem('token')
    if (window.localStorage.getItem('token')) {
      // 存购物车数量
      const num = await getShopNum()
      window.localStorage.setItem('shopNum', num.data)
    }
    this.handleLoginFromWx();
    this.hotActivity();
    this.imageShop()
    this.imgWord()
    if (localStorage.userInfo) {
      this.uInfo = localStorage.getItem('userInfo')
      // console.log(this.uInfo)
      this.headShow = true;
    } else if (!localStorage.userInfo) {
      this.headShow = false;
    }

    // this.$axios
    //   .post("/work/taglist", {})
    //   .then((res) => {
    //     this.tags = res.result.list;
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // this.search(0, 1);
    // this.searchs(0, 1);
  },
  components: {
    Top,
    Rotation,
    Foot,
    Skeleton,
    service,
    shopFloat
  },
};
</script>

<style lang="scss" scoped>
.banxin {
  width: 1600px;
  margin: 0 auto;
}

// // 移动端
// @media screen and (min-width: 375px) and (max-width: 1000px) {
//   .banxin {
//     width: 100%;
//     margin: 0 auto;
//   }

//   .top1box {
//     .box1 {
//       width: 25% !important;
//     }

//     .box2 {
//       width: 18% !important;
//     }
//   }

//   // 征稿
//   .active-name {
//     .name-img {
//       width: 33.2% !important;
//       height: 230px !important;
//     }
//   }

//   // 精品图片
//   .jpimgbox {
//     .demonstration-img {
//       width: 948px !important;
//       height: 587px !important;
//     }

//     .jpimgcon {
//       .imgBox {
//         width: 468px !important;
//         height: 288px !important;
//       }
//     }
//   }

//   //精品视频
//   .jpvideocon {
//     .vBox {
//       width: 948px !important;
//       height: 587px !important;
//     }

//     .imgBox2 {
//       width: 468px !important;
//       height: 288px !important;
//     }
//   }

//   // 影像馆
//   .museumBox {
//     height: 980px !important;

//     //  图片位
//     .conBox {
//       width: 1440px !important;

//       .box1 {
//         width: 948px !important;
//         height: 587px !important;
//       }

//       .box2 {
//         width: 468px !important;
//         height: 288px !important;
//       }
//     }

//     //文字位
//     .museumWord {
//       width: 468px !important;
//       height: 885px !important;

//       .worditem {
//         height: 123px !important;
//         font-size: 20px !important;

//         img {
//           width: 55px !important;
//           height: 55px !important;
//         }

//         .text {
//           width: 205px !important;
//         }
//       }
//     }
//   }

//   //摄影师
//   .photographer {
//     ul {
//       li {
//         width: 308px !important;
//         height: 308px !important;
//       }
//     }
//   }

//   .sysbox {
//     padding: 0 20px;
//   }

//   .jpimgtop {
//     margin: 90px auto 30px !important;
//     padding: 0 20px !important;
//   }
// }


body,
html {
  padding: 0;
  border: 0;
  margin: 0;
}


@-webkit-keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

@keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

// 图片遮罩

#posTop {
  width: 100%;
  height: 35px;
  background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
  position: absolute;
  left: 0;
  top: -50px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  padding: 0 10px;
  z-index: 11;

  .address {
    color: #fff;
    font-size: 13px;
  }
}

#posBottom {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
  position: absolute;
  left: 0;
  bottom: -50px;
  transition: all 0.2s;
  padding: 0 10px;
  z-index: 11;

  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  .name {
    margin-left: 8px;
    color: #fff;
    font-size: 13px;
  }
}

.index {
  width: 100%;
  font-family: "Microsoft YaHei";
}

.index /deep/ .top {
  min-width: 100%;
  background-color: #fff;
}

.index /deep/ .com {
  width: 60%;
}

// 头部样式
.top1box {
  margin: 20px auto;
  width: 100%;
  height: 280px !important;
  display: flex;
  justify-content: space-between;

  .box1 {
    width: 520px;
    height: 100%;
    background-color: #fff;
    padding-top: 29px;
    padding-left: 19px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      -webkit-transform: translate3d(0, -2px, 0);
      -webkit-box-shadow: 0 3px 6px rgba(34, 33, 33, 0.2);
      transform: translate3d(0, -2px, 0);
      box-shadow: 0 3px 6px rgba(34, 33, 33, 0.2);
    }

    .imgbox {
      background-color: #f3f3f3;
      width: 75px;
      height: 75px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .img {
        width: 50px;
        height: 50px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    p {
      margin-top: 10px;
      font-size: 16px;
      font-weight: bold;
    }

    .text {
      margin-top: 20px;
      width: 100%;
      display: flex;

      p {
        padding-left: 16px;
        font-weight: normal;
        font-size: 13px;
        color: #979797;
        margin-bottom: 8px;

        span {
          color: #dc3b3b;
          font-size: 14px;
          font-weight: bold;
        }
      }

      .t1 {
        width: 50%;
      }

      .t2 {
        width: 50%;
      }
    }
  }

  .box2 {
    width: 255px;
    height: 100%;
    background-color: #fff;
    padding-top: 29px;
    padding-bottom: 18px;
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      transform: translate3d(0, -2px, 0);
      box-shadow: 0 3px 8px rgba(34, 33, 33, 0.2);
    }

    .imgbox {
      background-color: #f3f3f3;
      width: 75px;
      height: 75px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .img {
        width: 50px;
        height: 50px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    p {
      font-size: 16px;
      font-weight: bold;
      margin-top: 10px;
    }

    .text {
      margin-top: 20px;

      p {
        font-size: 13px;
        font-weight: normal;
        color: #979797;

        span {
          font-weight: bold;
          font-size: 14px;
          color: #dc3b3b;
        }
      }
    }
  }
}


.el-container {
  width: 100%;
  margin: 20px auto;
}

// 图片征稿

.zgheader {
  margin: 50px 0 0px 0;

  p {
    font-size: 23px;
    font-weight: 500;
  }
}

.active-name {
  width: 100%;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;

  .name-img {
    // width: 418px;
    // height: 166px;
    width: 524px;
    height: 166px;
    overflow: hidden;
    position: relative;
    /* 以下代码实现背景动画效果 */
    animation: loading 1.4s ease infinite;
    -webkit-animation: loading 1.4s ease infinite;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
    background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
    background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
    background-size: 400% 100%;

    transition: all .3s;

    &:hover {
      transform: translate3d(0, -3px, 0);
      box-shadow: 0 3px 8px rgba(21, 20, 20, 0.5);
    }


    img {
      // object-fit: cover;
      // height: 100%;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

// 精品图片
.jpimgtop {
  width: 100%;
  height: 30px;
  margin: 50px auto 10px;

  .text {
    font-size: 23px;
    font-weight: 500;
  }

  .imgMore {
    float: right;
    padding-right: 20px;
  }
}

.jpimgbox {
  margin-top: 30px;
  width: 100%;
  margin: 0 auto;

  .jpimgcon {
    border: none;
    padding-top: 15px;
    overflow-y: hidden;
    overflow-x: hidden;

    .imgBox {
      // width: 309px;
      // height: 228px;
      width: 308px;
      height: 228px;
      margin: 0 14px 12px 0;
      object-fit: cover;
      float: left;
      position: relative;
      overflow: hidden;

      &:nth-child(3) {
        margin-right: 0;
      }

      &:nth-child(5) {
        margin-right: 0;
      }

      &:nth-child(10) {
        margin-right: 0;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        /* 以下代码实现背景动画效果 */
        animation: loading 1.4s ease infinite;
        -webkit-animation: loading 1.4s ease infinite;
        background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
        background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
        background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
        background-size: 400% 100%;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.02);
        }
      }

      &:hover #posBottom {
        bottom: 0,
      }

      &:hover #posTop {
        top: 0,
      }
    }

  }
}

.demonstration-img {
  // background-color: #ccc;
  float: left;
  margin: 0 13px 12px 0;
  // width: 632px;
  // height: 465px;
  width: 951px;
  height: 467px;
  overflow: hidden;

  /* 以下代码实现背景动画效果 */
  animation: loading 1.4s ease infinite;
  -webkit-animation: loading 1.4s ease infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
  background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-size: 400% 100%;


  /deep/ .el-carousel__container {
    position: relative;
    width: 100% !important;
    height: 100% !important;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &:hover #posBottom {
      bottom: 0,
    }

    &:hover #posTop {
      top: 0,

    }

    #posTop {
      width: 100%;
      height: 40px;
      background: -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      top: -50px;
      transition: all 0.2s;
    }

    #posBottom {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
      position: absolute;
      left: 0;
      bottom: -50px;
      transition: all 0.2s;
      padding: 0 10px;

      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }

      .name {
        margin-left: 8px;
        color: #fff;
        font-size: 13px;
        font-weight: bold;
      }


    }


  }
}


// 精品视频
// 精品视频
.jpvideotop {
  width: 100%;
  height: 30px;
  margin: 50px auto 10px;

  .text {
    font-size: 23px;
    font-weight: 500;
  }

  .more {
    float: right;
    padding-right: 20px;
  }
}

.jpvideobox {
  margin-top: 30px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  .jpvideocon {
    border: none;
    padding-top: 15px;

    .imgBox2 {
      width: 308px;
      height: 172px;
      margin: 0 14px 12px 0;
      object-fit: cover;
      float: left;
      position: relative;
      overflow: hidden;

      &:nth-child(3) {
        margin-right: 0;
      }

      &:nth-child(5) {
        margin-right: 0;
      }

      &:nth-child(10) {
        margin-right: 0;
      }

      .shichang {
        font-size: 12px;
        position: absolute;
        bottom: 8px;
        right: 8px;
        border-radius: 10px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 2px 8px;
        z-index: 1;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        /* 以下代码实现背景动画效果 */
        animation: loading 1.4s ease infinite;
        -webkit-animation: loading 1.4s ease infinite;
        background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
        background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
        background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
        background-size: 400% 100%;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.02);
        }
      }

      &:hover #posBottom {
        bottom: 0,
      }

      &:hover #posTop {
        top: 0,
      }
    }
  }
}




.vBox {
  float: left;
  position: relative;
  margin: 0 15px 12px 0;
  width: 952px;
  height: 355px;
  // width: 632px;
  // height: 354px;
  overflow: hidden;
  /* 以下代码实现背景动画效果 */
  animation: loading 1.4s ease infinite;
  -webkit-animation: loading 1.4s ease infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
  background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-size: 400% 100%;

  .shichang {
    font-size: 12px;
    position: absolute;
    bottom: 8px;
    right: 8px;
    border-radius: 10px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 2px 8px;
    z-index: 1;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover #posBottom {
    bottom: 0,
  }

  &:hover #posTop {
    top: 0,
  }


}

// 影像馆

.yxgtop {
  width: 100%;
  height: 30px;
  margin: 50px auto 30px;

  .text {
    font-size: 23px;
    font-weight: 500;
  }

  .more {
    float: right;
    padding-right: 20px;
  }
}

.yxgmain {
  padding: 0px;

  .yxgcon {
    margin-top: 30px;
    width: 966px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    height: 600px;

    .yxgbox {
      border: none;
    }
  }
}

.yxgimgbox {
  position: relative;

  img {
    width: 305px;
    height: 172px;
    position: absolute;
  }

  .yxgheader {
    color: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    position: absolute;
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;

    .yxgheaderimg {
      width: 40px;
      height: 40px;
      margin-bottom: 16px;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }

    p {
      text-align: center;
      border: 1px solid #fff;
      padding: 5px 8px;
      border-radius: 20px;
    }
  }
}

.yxgwordbox {
  width: 250px;
  height: 558px;
  margin: 0 13px 0px 0px;
  background-color: #fff;
  /* 以下代码实现背景动画效果 */
  // animation: loading 1.4s ease infinite;
  // -webkit-animation: loading 1.4s ease infinite;
  // background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
  // background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  // background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  // background-size: 400% 100%;
}

//++++++++++++++++++++++++++++++++++++++++++++++++++++
.demonstration {
  float: left;
  margin: 0 12px 12px 0;
  // width: 626px;
  // height: 364px;

  // position: absolute;
  // z-index: 2;
  width: 100%;
  height: 100%;

  // left: 0px;
  // top: 0px;
  /deep/ .el-carousel__container {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  // line-height: 280px;
  margin: 0 auto;
}

.demonstration2 {
  float: left;
  margin: 0 12px 12px 0;
  width: 620px;
  height: 364px !important;
  overflow: hidden;
  // position: absolute;
  // z-index: 2;
  // width: 100%;
  // height: 100%;
  // left: 0px;
  // top: 0px;
}

.rect-div-wrap {
  width: 305px;
  height: 172px;
  margin: 0 12px 20px 0;
  float: left;
  position: relative;
}

.rect-img-wrap {

  /* 以下代码实现背景动画效果 */
  animation: loading 1.4s ease infinite;
  -webkit-animation: loading 1.4s ease infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
  background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-size: 400% 100%;

}

.rect-img-wrap>img {
  height: 228px;
  object-fit: cover;
}

.rect-img-wraps {
  margin: 0 12px 20px 0;
  object-fit: cover;

}

.rect-img-wraps>img {
  // width: 100%;
  // height: 100%;
  object-fit: cover;
}

.rotation2 {
  float: left;
}

.btns {
  position: relative;
  background: url('../imgs/Rectangle.jpg') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 280px;
  margin: 40px auto;
  padding: 36px 0px 0px 0px;
}

.btn {
  // text-align: center;
  // line-height: 64px;
  position: absolute;
  width: 334px;
  height: 64px;
  font-size: 24px;
  color: #ffffff;
  background-color: #e34646;
  margin: 0 auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: none;
}

.icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  background-image: url("../imgs/befor.svg");
  background-repeat: no-repeat;
  //  position: absolute;
  // top: 24%;
  margin-right: 10px;
  z-index: 2;
}

//  影像馆（最新）
.museumBox {
  width: 100%;
  height: 565px;
  margin: 20px auto;

  // 图片位
  .conBox {
    // width: 972px;
    // height: 100%;
    width: 1290px;
    height: 100%;
    float: left;

    .box1 {
      overflow: hidden;
      // width: 633px;
      // height: 364px;
      width: 952px;
      height: 364px;
      float: left;
      margin-right: 15px;
      position: relative;

      /* 以下代码实现背景动画效果 */
      animation: loading 1.4s ease infinite;
      -webkit-animation: loading 1.4s ease infinite;
      background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
      background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
      background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
      background-size: 400% 100%;

      .top {
        position: absolute;
        background: none;
        top: 0;
        height: 60px;
        width: 100%;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        z-index: 7;

        img {
          border-radius: 50%;
          width: 40px;
          height: 40px;
        }

        p {
          padding-left: 13px;
          font-size: 18px;
          flex: 1;
        }

        .look {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 120px;
          height: 36px;
          border-radius: 20px;
          border: 2px solid #fff;

        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .box2 {
      overflow: hidden;
      margin-right: 14px;
      margin-bottom: 14px;
      float: left;
      width: 308px;
      height: 176px;
      position: relative;
      /* 以下代码实现背景动画效果 */
      animation: loading 1.4s ease infinite;
      -webkit-animation: loading 1.4s ease infinite;
      background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
      background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
      background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
      background-size: 400% 100%;

      .name {
        text-align: center;
        width: 230px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        color: #fff;
        z-index: 9999999;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;


      }

      .msk {
        position: absolute;
        top: 0%;
        left: 0%;
        width: 100%;
        height: 100%;
        transition: all .3s;
        background-color: rgba(0, 0, 0, .2);

        &:hover {
          background-color: rgba(0, 0, 0, .3);
        }
      }
    }
  }

  // 文字位
  .museumWord {
    float: right;
    height: 556px;
    // width: 308px;
    width: 308px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    overflow: hidden;

    .worditem {
      width: 100%;
      height: 93px;
      background-color: #fff;
      line-height: 93px;
      font-size: 15px;
      transition: all .2s;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .img {
        left: 35px;
        position: absolute;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        // box-shadow: 1px 1px 1px 1px #333;
      }

      .text {
        transform: translateX(10px);
        width: 165px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:hover {
        background-color: #db3a3b;
        color: #fff;
      }
    }

  }


}



.herder-avatar {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  background: #f6f6f6;
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

// 影像管轮播图
.carousel-top {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 70px;
  // background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  z-index: 99999;
}

.carousel-left {
  display: flex;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
  }

  p {
    font-size: 12px;
    font-family: MicrosoftYaHei-Bold;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
  }
}

.el-button.is-round {
  border-radius: 31px;
  box-sizing: border-box;
  border: 1px solid #ffffff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0);
  width: 120px;
  height: 36px;
  color: #ffffff;
  line-height: 11px;
}

.photo-word {
  .el-dropdown-menu__item {
    height: 93px;
    line-height: 93px;
    font-size: 15px;
    font-weight: bold;
  }
}

.photographer {
  margin: auto;
  margin-top: 60px;
  width: 100%;

  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      margin-bottom: 15px;
      margin-right: 15px;
      /* 以下代码实现背景动画效果 */
      animation: loading 1.4s ease infinite;
      -webkit-animation: loading 1.4s ease infinite;
      background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #ccc), color-stop(37%, #e3e3e3), color-stop(63%, #ccc));
      background-image: -o-linear-gradient(left, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-image: linear-gradient(90deg, #ccc 25%, #e3e3e3 37%, #ccc 63%);
      background-size: 400% 100%;
      width: 130px;
      height: 130px;

      &:nth-child(11n) {
        margin-right: 0;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #db3a3b;
  color: #fff;
}

// 摄影师
.sysbox {
  width: 100%;
  height: 30px;
  margin: 50px auto 30px;
  font-size: 23px;
  font-weight: 500;

  p {
    font-size: 23px;

  }
}

#big {
  transition: 0.5s;

  &:hover {
    font-weight: 700;
  }
}


// 轮播图显示器
/deep/ .el-carousel__button {
  display: block;
  width: 8px;
  height: 8px;
  background: #f5f5f5;
  border-radius: 50%;
  opacity: 0.7;
  border: 0 !important;
  border-radius: 50%;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
}

/deep/ .el-carousel__indicator.is-active button {
  width: 22px;
  height: 7px;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue